import { render, staticRenderFns } from "./ColorMemory.vue?vue&type=template&id=eb9d155c&lang=html"
import script from "./ColorMemory.vue?vue&type=script&lang=js"
export * from "./ColorMemory.vue?vue&type=script&lang=js"
import style0 from "./ColorMemory.vue?vue&type=style&index=0&id=eb9d155c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports